import React, { Component } from "react";
import Popup from "./Popup";
import Strings from "@my-dld/assets/strings";
import { MessageData } from "@my-dld/reducers/TempData";
import { dispatch } from "@my-dld/utils/StoreUtils";
import { TempDataActions } from "@my-dld/actions";

interface Props {
	data: MessageData;
}

class MessageInfoPopup extends Component<Props> {
	onDismiss = () => {
		dispatch( TempDataActions.HIDE_MESSAGE );
	};
	hide = () => {
		Popup.Dismiss( "message_info" );
	};

	render() {
		const { data } = this.props;
		const { message, options } = data;
		const { icon, noOkButton, okLabel, iconWrap, title } = options;
		return (
			<Popup
				autoOpenMount={ true } id={ "message_info" } onDismiss={ this.onDismiss } iconClass={ icon } iconClassWrapper={ iconWrap }
				title={ title }>
				<div className="modal-body">
					<div className="text-center modal-msg" id="exampleModalLabel">{ message }</div>
				</div>
				{ !noOkButton &&
					<div className="modal-footer row pb-0 d-flex justify-content-center">
						<button
							type="button" className="btn btn_1 btn_style1"
							onClick={ this.hide }>
							{ okLabel ?? Strings.ok }
						</button>
					</div>
				}
			</Popup>
		);
	}
}

export default MessageInfoPopup;
